import React from 'react';

import {useThreadDraft} from 'features/drafts';

import {useVirtualizedContext} from 'components/threading/virtualized_thread_viewer/virtualized_context';

import CreateComment from './create_comment';
import type {Props} from './create_comment';

const CreateCommentMemo = React.memo(CreateComment);

export function WithCommentDraft(props: Omit<Props, 'draft' | 'intl'>) {
    const draft = useThreadDraft(props.rootId);
    const {scrollToBottom} = useVirtualizedContext();

    return (
        <CreateCommentMemo
            key={props.rootId}
            draft={draft}
            onReplyHandle={scrollToBottom}
            {...props}
        />
    );
}
